// eslint-disable-next-line import/prefer-default-export
export const namespace = 'features.settings.back_flow_types.index';
export const supportEmail = 'support@inspectpoint.com';
